import React from 'react';
import Modal from 'react-responsive-modal';
import Translate from 'translate';
import { Card, CardText } from 'material-ui';

export default ( { data, onClose, open } ) => {
  return (
    <Modal closeOnEsc={false}
           little
           modalClassName="col-md-4"
           open={open}
           onClose={onClose}>
      <h5 className="mt-0"><Translate id="imsDetail"/></h5>

      { data  &&
      <Card>

      
      <CardText>
      <div className="col-md-12 p-0">
        <div className="row">
          <div className="col-md-3"><Translate id="callLabel"/></div>
          <div className="col-md-9 text-small text-muted">{data.callLabel}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="status"/></div>
          <div className="col-md-9 text-small text-muted">{data.callStatusLabel || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="creationDate"/></div>
          <div className="col-md-9 text-small text-muted">{data.date || '---'}</div>
        </div>
        
        <div className="row">
          <div className="col-md-3"><Translate id="incidentType"/></div>
          {data.callTypeDescription ? 
            <div className="col-md-9 text-small text-muted">{data.callTypeDescription || '---'}</div>
          :
            <div className="col-md-9 text-small text-muted">{data.callType || '---'}</div>
          }
        </div>

        <div className="row">
          <div className="col-md-3"><Translate id="incidentSubType"/></div>
          {data.callSubTypeDescription ?
            <div className="col-md-9 text-small text-muted">{data.callSubTypeDescription || '---'}</div>
          :
            <div className="col-md-9 text-small text-muted">{data.callSubType || '---'}</div>
          }
        </div>

      </div>
      </CardText></Card>
      }
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./routes/app/components/Agent/CheckImsLECModal/index.js